/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const postApiSystemEmailDomainClassificationsBody = zod.object({
  "domain": zod.string(),
  "isPublic": zod.boolean(),
  "replayUserId": zod.string().uuid().nullish(),
  "replayEmail": zod.string().nullish(),
  "replayPhone": zod.string().nullish(),
  "replayInvitationType": zod.string().nullish()
})

